import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const SulphiteIcon = ({
  innerColor = '#fefefe',
  outerColor = '#8d2f51',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_124"
        data-name="Grupo 124"
        transform="translate(-84.5 -2094)"
      >
        <g
          id="Rectángulo_15"
          data-name="Rectángulo 15"
          transform="translate(84.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="sulphite" transform="translate(92.724 2100.904)">
          <path
            id="Trazado_9084"
            data-name="Trazado 9084"
            d="M58.848,6.641a4.869,4.869,0,0,1-.8-2.683V2.328h.81V0H54.169V2.328h.81V3.959a4.869,4.869,0,0,1-.8,2.683l-2.94,4.469v2.082H61.788V11.111Zm-3.9-5.089V.776h3.133v.776H54.945Zm.81,2.407V2.328h1.514V3.959A5.643,5.643,0,0,0,58.2,7.068l.082.125h-3.54l.082-.125A5.643,5.643,0,0,0,55.755,3.959Zm5.257,8.458h-9V11.343l2.22-3.375h4.561l2.22,3.375v1.074Z"
            transform="translate(-51.236 0)"
          />
          <path
            id="Trazado_9085"
            data-name="Trazado 9085"
            d="M168.01,341.7c0-.07.064-.129.266-.129a1.263,1.263,0,0,1,.57.152l.208-.5a1.625,1.625,0,0,0-.772-.178c-.635,0-.954.31-.954.69,0,.763,1.132.556,1.132.813,0,.07-.07.111-.266.111a1.4,1.4,0,0,1-.676-.187l-.222.5a1.835,1.835,0,0,0,.892.211c.635,0,.953-.316.953-.69C169.142,341.74,168.01,341.945,168.01,341.7Z"
            transform="translate(-164.305 -332.256)"
          />
          <path
            id="Trazado_9086"
            data-name="Trazado 9086"
            d="M253.356,341.044a1.074,1.074,0,1,0,1.155,1.071A1.08,1.08,0,0,0,253.356,341.044Zm0,1.582a.515.515,0,1,1,.459-.512A.466.466,0,0,1,253.356,342.626Z"
            transform="translate(-247.023 -332.256)"
          />
          <path
            id="Trazado_9087"
            data-name="Trazado 9087"
            d="M347.086,409.707a.2.2,0,0,1,.176-.111c.077,0,.116.036.116.094,0,.041-.012.087-.094.164l-.432.4v.248h.959v-.313h-.4l.171-.155a.471.471,0,0,0,.205-.381c0-.227-.2-.374-.484-.374a.549.549,0,0,0-.518.277Z"
            transform="translate(-339.167 -398.732)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default SulphiteIcon;
